import type { ApiResponse } from "@/types/api";
import { getClient } from "@/services/ApiService";

const secured = () => getClient();

/** Swagger: StatementPaymentResult */
export interface StatementPaymentResult {
  success: boolean;
  reason: string;
  amountPaid: number;
  /** Still owed on the statement after this payment. */
  balanceDue: number;
  receiptEmailed: boolean;
  /** False when the card was charged but the API couldn't record it; the office applies it by hand. */
  posted?: boolean;
  /** A new card was saved to the patient's cards for future payments. */
  cardSaved?: boolean;
}

/** Swagger: StatementNewCardStartResult */
export interface StatementNewCardStartResult {
  success: boolean;
  reason: string;
  posID: number;
  clientToken: string;
  environment: string;
  scriptUrl: string;
}

interface StatementPaymentKeys {
  facilityKey: string;
  patientKey: string;
  taskID: number;
}

export default {
  request: {
    /** Pay all or part of a STMT task's balance with a saved Fortis card (PaymentProfile.ID). */
    async payWithSavedCard(
      payload: StatementPaymentKeys & { amount: number; paymentProfileID: number; email: string }
    ): Promise<ApiResponse<StatementPaymentResult>> {
      return secured().post("/Portal/StatementPayment/SavedCard", payload);
    },

    /** Start a new-card payment: returns the Commerce.js client token and the PosID to complete with. */
    async startNewCard(
      payload: StatementPaymentKeys & { amount: number; saveCard: boolean; saveTitle: string }
    ): Promise<ApiResponse<StatementNewCardStartResult>> {
      return secured().post("/Portal/StatementPayment/NewCard/Start", payload);
    },

    /** Post a new-card sale once Commerce.js reports it done. Safe to repeat. */
    async completeNewCard(
      payload: StatementPaymentKeys & { posID: number; transactionID: string; email: string }
    ): Promise<ApiResponse<StatementPaymentResult>> {
      return secured().post("/Portal/StatementPayment/NewCard/Complete", payload);
    },
  },
};
